module.exports = __webpack_public_path__ + "assets/img/lanya.6aace1b7.png";